import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/Newsletter/newsletter.container"
    ).then((module) => ({
        default: module.NewsLetterContainer
    }))
);
